/**
 * R24 · Karten-Politur: Farbpunkte aus Varianten-Tokens
 *
 * Ausgelagert aus snippets/r24-card-polish.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function () {
  /* Vom Theme bereits definierte Farbtokens — NICHT anfassen (laden lazy korrekt). */
  var DEFINED = {};
  ['anthrazit','aschegrau','beige','beige-weiss','blau','braun','burgunderrot','cappuccino',
   'creme','dunkle-eiche','elfenbein','flamingo','gold','graphit','grau','grau-hochglanz',
   'halifax-eiche','halifax-eiche-weiss','hellgrau','hellgrau-matt','mintgrun','nerz','olive',
   'opalweiss-cremona-eiche','schwarz','schwarz-grau','schwarz-matt','schwarz-weiss','silber',
   'terrakotta','vergissmeinnicht-blau','weiss-hochglanz','weiss-matt','wintermoos','wolkenweiss'
  ].forEach(function (k) { DEFINED[k] = 1; });

  /* Basis-Farb-/Holzton-Map (Tokens sind handleized: klein, „-"-getrennt, ü->u). */
  var C = {
    weiss:'#eef0f2', reinweiss:'#f4f6f8', wolkenweiss:'#f0f2f3', opalweiss:'#eef0ef',
    schwarz:'#26292e', graphit:'#33383f', schiefer:'#4a525b',
    grau:'#9aa1aa', hellgrau:'#c9ced4', dunkelgrau:'#5f6670', mausgrau:'#8c8c86',
    aschegrau:'#a7a9a5', anthrazit:'#3d444d', silber:'#c4c8ce', stein:'#a8a59d',
    beige:'#e0d3bd', dunkelbeige:'#c9b38f', hellbeige:'#ece0cb', sand:'#d8c6a2',
    creme:'#efe7d7', elfenbein:'#ece4cf', vanille:'#efe4c4', kaschmir:'#d8ccb6',
    cappuccino:'#a98b6c', mokka:'#6b4f3a', nerz:'#8c7a67', taupe:'#b6a794',
    braun:'#7c5836', dunkelbraun:'#5a4028', schoko:'#4d3526',
    gold:'#c7a052', kupfer:'#b5713f', bronze:'#9a7b4f', messing:'#b79a56',
    gelb:'#e3bd54', senf:'#c99a3a', ocker:'#c08a3a', orange:'#e08a3c',
    blau:'#3f6fac', hellblau:'#8fb6df', dunkelblau:'#2a4a78', navy:'#26375f',
    petrol:'#2f6d74', taubenblau:'#6d8199', vergissmeinnicht:'#7aa6dd',
    grun:'#5db487', dunkelgrun:'#2f6b45', hellgrun:'#8fd0a8', mint:'#a3d7bf',
    mintgrun:'#a3d7bf', salbei:'#9caf8f', oliv:'#7d7f4e', olive:'#7d7f4e',
    khaki:'#9a8f5f', tanne:'#2f5d3f', wintermoos:'#5b6b4a', moos:'#5b6b4a',
    rosa:'#e3a2b4', altrosa:'#c98f97', flamingo:'#e79aad', koralle:'#e4796c',
    rot:'#c23b30', kirschrot:'#b32b2b', weinrot:'#7a2230', burgunderrot:'#6f2a34',
    bordeaux:'#6f2a34', terrakotta:'#b56a4c', ziegel:'#a75844',
    lila:'#9a6fb5', flieder:'#b9a6d4', violett:'#8a6bbf',
    /* Holzdekore */
    eiche:'#c39a63', pinie:'#d5b483', kiefer:'#d5b483', buche:'#d3a877', ahorn:'#d8bc8a',
    nussbaum:'#5a3d28', walnuss:'#5a3d28', wenge:'#3f2e23', akazie:'#a9773f',
    woodline:'#c8a978', sonoma:'#c8ab7d', artisan:'#b98f5f', wotan:'#8f7d68',
    abisko:'#c2a074', london:'#8a6b4a', catania:'#a07b50', halifax:'#caa877',
    andersen:'#d8c3a0', cremona:'#c39a63', gold_eiche:'#cba368', natur:'#c39a63', holz:'#c39a63',
    /* Polsterstoff-Codes als DATEN (best-effort Farbwerte je Kollektion/Nummer;
       exakte Töne ggf. später gegen echte Varianten-Farbdaten austauschen). */
    cover02:'#b9b3a8', inari96:'#9ea2a4',
    kronos09:'#d8ccb4', kronos19:'#9a9994',
    matvelvet68:'#a38f6a', matvelvet99:'#3f4246',
    'monolith09':'#c9ccce', 'monolith29':'#9a9ea1', 'monolith37':'#ccb899',
    'monolith48':'#7d6552', 'monolith63':'#6b6f72', 'monolith77':'#8f847a',
    'monolith84':'#4a4d50', 'monolith92':'#5a4b3f', 'monolith97':'#b79a52',
    omega13:'#b7bcc0', omega68:'#5f6b74', omega86:'#7f7488', omega91:'#7a6f66',
    'orinoko-21':'#9a8f7a', palast77:'#8f8477'
  };
  /* mehrteilige Holz-/Farbnamen zuerst prüfen */
  var COMPOUND = {
    'gold-eiche':'#cba368', 'dunkle-eiche':'#6e4e30', 'artisan-eiche':'#b98f5f',
    'wotan-eiche':'#8f7d68', 'sonoma-eiche':'#c8ab7d', 'abisko-eiche':'#c2a074',
    'london-eiche':'#8a6b4a', 'catania-eiche':'#a07b50', 'halifax-eiche':'#caa877',
    'andersen-pinie':'#d8c3a0', 'dunkelgrau':'#5f6670', 'hellgrau':'#c9ced4',
    'dunkelbeige':'#c9b38f', 'hellbeige':'#ece0cb', 'dunkelblau':'#2a4a78',
    'dunkelgrun':'#2f6b45', 'mausgrau':'#8c8c86', 'aschegrau':'#a7a9a5'
  };

  function colorFor(tok) {
    if (COMPOUND[tok]) return COMPOUND[tok];
    if (C[tok]) return C[tok];
    var parts = tok.split(/[-_]/);
    /* zusammengesetzte Zwei-Wort-Keys (z.B. "beige-eiche") */
    for (var j = 0; j < parts.length - 1; j++) {
      var pair = parts[j] + '-' + parts[j + 1];
      if (COMPOUND[pair]) return COMPOUND[pair];
    }
    /* erstes erkennbares Wort gewinnt (Finish/Zahlen überspringen) */
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p || p === 'matt' || p === 'hochglanz' || p === 'glanz' || /^\d+$/.test(p)) continue;
      if (C[p]) return C[p];
      if (/eiche/.test(p)) return C.eiche;
      if (/pinie|kiefer/.test(p)) return C.pinie;
      if (/nussbaum|walnuss/.test(p)) return C.nussbaum;
      if (/wenge/.test(p)) return C.wenge;
    }
    /* Holz-Fallbacks über den ganzen Token */
    if (/eiche|oak/.test(tok)) return C.eiche;
    if (/pinie|kiefer|pine/.test(tok)) return C.pinie;
    if (/woodline|sonoma|wotan|abisko|catania|halifax|london|andersen|artisan|cremona/.test(tok)) return '#c39a63';
    return null; /* unbekannt (Stoffcode) -> neutraler Platzhalter */
  }

  function paint() {
    var els = document.querySelectorAll('[class*="bg_color_"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-r24-sw')) continue;
      var m = (el.className.match(/bg_color_([a-z0-9_\-]+)/i) || [])[1];
      if (!m) continue;
      m = m.toLowerCase();
      if (DEFINED[m]) { el.setAttribute('data-r24-sw', 'skip'); continue; }
      var cs = getComputedStyle(el);
      var empty = cs.backgroundImage === 'none' &&
        (cs.backgroundColor === 'rgba(0, 0, 0, 0)' || cs.backgroundColor === 'transparent');
      if (!empty) { el.setAttribute('data-r24-sw', 'ok'); continue; }
      /* SWATCH VARIANTEN-DATEN BINDEN: echte Varianten-Farbe hat Vorrang —
         wenn am Swatch (oder Eltern) ein Varianten-Bild hinterlegt ist, dieses
         als Chip zeigen (echte Daten); erst danach die kuratierte Namens-Farbe;
         zuletzt neutraler Platzhalter. */
      var vimg = el.getAttribute('data-bg') || el.getAttribute('data-img');
      if (!vimg) { var pp = el.closest('[data-bg],[data-img]'); if (pp) vimg = pp.getAttribute('data-bg') || pp.getAttribute('data-img'); }
      if (vimg && /\/cdn\/shop\//.test(vimg)) {
        var url = vimg.indexOf('//') === 0 ? (location.protocol + vimg) : vimg;
        el.style.setProperty('background-image', 'url("' + url + '")', 'important');
        el.style.setProperty('background-size', 'cover', 'important');
        el.style.setProperty('background-position', 'center', 'important');
        el.setAttribute('data-r24-sw', 'vimg');
        continue;
      }
      var hex = colorFor(m);
      if (hex) { el.style.setProperty('background', hex, 'important'); el.setAttribute('data-r24-sw', 'fill'); }
      else { el.classList.add('r24-sw-ph'); el.setAttribute('data-r24-sw', 'ph'); }
    }
  }

  if (document.readyState !== 'loading') paint(); else document.addEventListener('DOMContentLoaded', paint);
  window.addEventListener('load', paint);
  var t;
  var sched = function () { clearTimeout(t); t = setTimeout(paint, 160); };
  window.addEventListener('scroll', sched, { passive: true });
  /* neue Karten (AJAX-Filter/Pagination) abdecken; nur childList, damit unsere
     eigenen style-Änderungen den Observer NICHT erneut auslösen. */
  try { new MutationObserver(sched).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
